<app-menu [hasChanges]="loadMenu" [title]="'Ventas acumuladas'"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-fluid pl-2 minScreen">

    <div class="pt-2 w-full md:w-2 mx-auto">
        <label>Seleccione  el rango de fechas</label>
        <div class="flex justify-content-center">
           
            <p-datepicker [(ngModel)]="rangeDates" selectionMode="range" readonlyInput="true" inputId="range"
                dateFormat="yy-mm-dd" showIcon="true"></p-datepicker>
            <div class="p-2">
                <button pButton icon="pi pi-search" class="p-button p-button-success"
                    (click)="getInfoVentas()"></button>
            </div>
        </div>
    </div>

    <div class="flex flex-wrap" *ngIf="this.infoPagos.length > 0">
        <div class="p-5 w-full md:w-4 mx-auto">
            <div class="text-center" id="pagos">
                <h4>Metodos de Pago</h4>
                <div class="flex" *ngFor="let row of infoPagos">
                    <div class="w-6">
                        {{row.referencia}} <span class="text-primary" *ngIf="row.referencia == 'Efectivo'"></span>
                    </div>
                    <div class="w-6">
                        {{row.valor | currency}}
                    </div>
                </div>
                <div class="flex flex-wrap">
                    <div class="w-6">
                        <h4>TOTAL VENTA</h4>
                    </div>
                    <div class="w-6">
                        <h4>{{ totalPagos | currency}}</h4>
                    </div>
                </div>
            </div>
            <div class="mx-auto w-min"><button pButton class="p-button p-button-success" label="Imprimir"
                    icon="pi pi-print" (click)="printDiv('pagos','Información de pagos')"></button></div>

        </div>
        <div class="p-5 w-12 md:w-4 mx-auto" *ngIf="infoAbonosCartera.length >0">
            <div class="text-center" id="abonos">
                <h4>Metodos de Pago - Abonos cartera</h4>
                <div class="flex" *ngFor="let row of infoAbonosCartera">
                    <div class="w-6">
                        {{row.metodoPago.metodoPago}}
                    </div>
                    <div class="w-6">
                        {{row.valor | currency}}
                    </div>
                </div>
                <div class="flex">
                    <div class="w-6">
                        <h4>TOTAL Abonos</h4>
                    </div>
                    <div class="w-6">
                        <h4>{{ totalAbonos | currency}}</h4>
                    </div>
                </div>
            </div>
            <div class="mx-auto w-min"><button pButton class="p-button p-button-success" label="Imprimir"
                    icon="pi pi-print" (click)="printDiv('abonos','Información de abonos')"></button></div>
        </div>

        <div class="p-5 w-full mx-auto">
            <div class="text-center w-full md:w-6 mx-auto" id="vendedor">
                <h4>Discriminación por vendedor</h4>
                <div class="flex" *ngFor="let row of infoVendedor">
                    <div class="w-6">
                        {{row.empleado.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.nombres}}
                        {{row.empleado.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.apellidos}}
                    </div>
                    <div class="w-6">
                        {{row.subtotal | currency}}
                    </div>
                </div>
                <div class="flex">
                    <div class="w-6">
                        <h4>TOTAL VENTA</h4>
                    </div>
                    <div class="w-6">
                        <h4>{{ totalPagos | currency}}</h4>
                    </div>
                </div>
            </div>
            <div class="mx-auto w-min"><button pButton class="p-button p-button-success" label="Imprimir"
                    icon="pi pi-print" (click)="printDiv('vendedor','Información por vendedor')"></button></div>
        </div>

        <div class="p-5 w-full md:w-8 mx-auto">
            <div class="text-center">
                <h4>Discriminación por categoría y producto</h4>
            </div>
            <p-treeTable [value]="infoVenta">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="text-center">Descripción</th>
                        <th class="text-center">Valores</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                    <tr>
                        <td class="text-center">
                            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                            {{rowData.label}}
                        </td>
                        <td class="text-center">Cantidad : {{rowData.cantidad}}<br>
                            Subtotal: {{rowData.subtotal | currency}}<br>
                            Impuesto: {{rowData.impuesto | currency}}<br>
                            TOTAL: {{rowData.subtotal + rowData.impuesto | currency}}</td>
                    </tr>
                </ng-template>
            </p-treeTable>
        </div>
    </div>
</div>
<p-toast>

</p-toast>
<!-- <app-footer></app-footer> -->